/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IClasificaciones from './entidades/clasificaciones';
import IFiltrosClasificaciones from './entidades/filtrosClasificaciones';

export default class ModeloClasificaciones {
    public consultarClasificaciones() {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocioConfiguracion.get('Clasificacion/ConsultarListaClasificacion')
        );
    }
    public crearClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocioConfiguracion.post('Clasificacion/GuardarClasificacion', clasificaciones)
        );
    }
    public editarClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocioConfiguracion.put('Clasificacion/EditarClasificacion', clasificaciones)
        );
    }
    public eliminarClasificaciones(clasificaciones: IClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(() =>
            negocioConfiguracion.delete('Clasificacion/EliminarClasificacion', clasificaciones)
        );
    }
    public consultarListaClasificacionesPorFiltro(filtrosClasificaciones: IFiltrosClasificaciones) {
        return manejadorRest<IRespuesta<IClasificaciones>>(
            () => negocioConfiguracion.post('Clasificacion/ConsultarListaClasificacionPorFiltro', filtrosClasificaciones),
            true
        );
    }
}
